<template>
  <div class="page-wrapper ticket-Order">
      <!-- 返回 -->
      <div class="movie-box">
        <MovieGoBack :style="backstyle" :arrowStyle="arrowStyle" :text="'提交订单'" :titleStyle="titleStyle"></MovieGoBack>
      </div>

        <div class="movie-box wrapper-content" v-if="Object.values(ticketDate).length!==0">
            <!-- 订单信息 -->
            <div class="movie-wrapper page-background-color-white ticket-order-info-wrapper">
                <div class="movie-box padding-top-bottom ticket-order-info-top">
                    <p>
                        {{ticketDate.title}}
                    </p>
                    <div class="movie-box acea-row row-between-wrapper ticket-text-color order-info-tip-wrapper">
                        <div class="ticket-type">
                            <div class="ticket-line">{{ticketDate.type}}</div>
                            购票截止：{{ticketDate.endTime}}
                        </div>

                        <div @click="closeNotice(true)">
                            预订须知  >
                        </div>
                    </div>
                </div>
                <!-- 选择日期和购买张数 -->
                <div class="movie-box padding-top-bottom ticket-order-info-bottom">
                    <p class="ticket-text-color ticket-margin-bottom">
                        使用日期
                    </p>
                    <ul class="movie-box page-relative acea-row font-color-red ticket-margin-bottom choose-date-wrapper">
                        <li v-for="(item, ind) in dateList" :key="ind" 
                        class="acea-row row-column row-center-wrapper ticket-margin-right date-modul" 
                        :class="{'no-ticket': !item.show, 'checked-date': (item.show && (checked_date.id === item.id))?true:false}" 
                        @click="checked_dateFn(item)"
                        v-if="dateList.length > 0">
                            {{item.time}}
                            <div class="ticket-font-size">{{item.show?item.price:'不可订'}}</div>
                        </li>

                        <li class="acea-row row-column row-center-wrapper ticket-margin-right date-modul"  v-if="dateList.length==0 && Object.keys(calendar_checked).length == 0">
                            请点击更多选择日期
                        </li>

                        <li v-if="Object.keys(calendar_checked).length !== 0" class="acea-row row-column row-center-wrapper ticket-margin-right date-modul" 
                        :class="{'no-ticket': !calendar_checked.show, 'checked-date': (calendar_checked.show && (checked_date.id === calendar_checked.id))?true:false}" 
                        @click="checked_dateFn(calendar_checked)">
                            {{calendar_checked.time}}
                            <div class="ticket-font-size">{{calendar_checked.show?calendar_checked.price:'不可订'}}</div>
                        </li>

                        <span class="page-absolute more" @click="openCalendarCheck">更多 > </span>
                    </ul>
                    <div class="ticket-text-color acea-row row-between-wrapper">
                        <p>最多购买{{ticket_max_number}}张</p>
                        <div class="acea-row row-middle row-between ticket-number-wrapper">
                            <span class="ticket-number ticket-reduce" @click="changeTicketNumber(0)">-</span>
                            {{ticket_number}}
                            <span class="ticket-number ticket-add" @click="changeTicketNumber(1)">+</span>
                        </div>
                    </div>
                </div>
            </div>
                <!-- 取票人信息 -->
                <div class="movie-wrapper page-background-color-white ticket-order-info-wrapper">
                    <div class="movie-box padding-top-bottom ticket-order-info-top">取票人信息</div>
                    <div class="movie-box ticket-order-info-bottom">
                        <label class="movie-box acea-row row-between-wrapper label-wrapper">
                            姓名<input class="input-text" type='text' placeholder="请输入姓名" required v-model.trim="ticket_collector.name" />
                        </label>
                        <label class="movie-box acea-row row-between-wrapper label-wrapper">
                            手机号<input class="input-text" type='text' placeholder="请输入手机号用于接收短信" required v-model.trim="ticket_collector.phone" />
                        </label>
                    </div>
                </div>
                <div class="movie-wrapper page-background-color-white ticket-order-info-wrapper font-color-red padding20">
                    因信息填写不完整，填写不正确造成的损失保险拒赔等问题，我司不承担相应责任，需由客人自行承担
                </div>

                <!-- 游客信息 -->
                <TicketAddTouristInfo :arr="arr" v-for="(v, k) in ticket_tourist" :key="k" :index="v.index" :item="v" @touristInfo="touristInfo"></TicketAddTouristInfo>

                <!-- 填写附加信息 -->
                <div class="movie-wrapper page-background-color-white ticket-order-info-wrapper page-padding-bottom2" v-if="this.resourceOrderExtendInfoList.length !== 0">
                    <div class="movie-box padding-top-bottom ticket-order-info-top">附加信息</div>
                    <div class="movie-box page-margin-top2" v-for="(item, ind) in resourceOrderExtendInfoList" :key="ind">
                        <TicketAdditionalInfor :name="item.OrderExtendInfoName" :all="item" :type="item.Type" :list="item.ResourceOrderExtendInfoItemList" @value="getValue"/>
                    </div>
                </div>

                <!-- 提交 -->
                <div @click="submit_order">
                   <MovieBottomButton :text="`共${amount} 提交订单`"></MovieBottomButton>
                </div>
        </div>
        <div v-else class="page-text-center page-margin-top3">
            !暂无信息请返回上一级页面
        </div>

        <!-- 点击提交订单-提示弹框 -->
        <MaskLayout :isShow="tipMask" @closeMask="closeMask" :contentStyle="maskStyle">
            <div class="movie-box padding30 mask-top-wrapper">
                <p class="page-text-center font-color-red page-margin-bottom2">提示</p>
                <ul class="movie-box ticket-text-color">
                    <li>票品名：{{`＜${orderInfor.title}＞`}}</li>
                    <li>出游日期：{{orderInfor.time}}</li>
                    <li>数量：{{orderInfor.number}}</li>
                    <li>总价：{{orderInfor.amount}}</li>
                </ul>
            </div>
            <div class="movie-box acea-row mask-bottom-wrapper">
                <div class="page-flex-1 page-text-center padding20 cancel-tab" @click="closeMask(false)">取消</div>
                <div class="page-flex-1 page-text-center padding20 font-color-red" @click="confirm">去支付</div>
            </div>
        </MaskLayout>

        <!-- 预订须知 -->
        <TicketNotice :notice="notice" :noticeList="noticeList" @noticeClose="closeNotice"></TicketNotice>

        <!-- 日历选择 -->
        <TicketCalendar :calendarShow="calendarShow" :datas="calendarPriceList" @closeCalendar="closeCalendar"></TicketCalendar>
  </div>
</template>

<script>
import MovieGoBack from "@components/MovieGoBack.vue";
import MovieBottomButton from "@components/MovieBottomButton.vue";
import TicketAddTouristInfo from "@components/TicketAddTouristInfo.vue";
import TicketCalendar from "@components/TicketCalendar.vue";
import MaskLayout from "@components/MaskLayout.vue";
import TicketNotice from "@components/TicketNotice.vue";
import TicketAdditionalInfor from "@components/TicketAdditionalInfor.vue";

import attrs, { required, chs_phone, chs_id, chs, alpha_letter } from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";
import { isEmpty } from "@utils/movie.js";
import { isType } from "@utils/index.js";
import { getTicketForScenicSpotsData, getCalendarPrice, preservationData } from "@api/ticket.js";
import { roundFun, addNumberBeforeZero, sort, judgeChinese } from "@utils/movie.js";

let new_tourist=[]; //游客信息第一层默认

export default {
    name: "TicketPlaceOrder",
    components: {
        MovieGoBack,
        MovieBottomButton,
        TicketAddTouristInfo,
        MaskLayout,
        TicketCalendar,
        TicketNotice,
        TicketAdditionalInfor
    },
    data: function() {
        return {
            backstyle: {
                background: '#fff'
            },
            arrowStyle: {
                color: '#666'
            },
            titleStyle: {
                color: '#666',
                'text-align': 'center',
                "font-size": '.29rem'
            },
            maskStyle: {
                top: "50%",
                left: "50%",
                width: "80%",
                "z-index": "111",
                "border-radius": ".2rem",
                transform: "translate(-50%, -50%)"
            },
            noticeList: [
                // {
                //     title: "有效期",
                //     content: [{content: "2021-12-24"}]
                // }
            ],
            dateList: [
                // {
                //     time: "时间",
                //     _time: "/Date(1625155200000+0800)/", //存值
                //     show: true/false, //是否可用
                //     price: 150, //价格
                //     id: ind, //伪id 下标
                //     _id: 1, //真正的id
                //     num: 200 //库存
                // }
            ],
            arr: [], //证件类型
            ticketDate: {
                title: "",//标题
                type: "", //类型
                endTime: "",//截止时间
                advanceDays: null //提前预定天数
            },
            ticketType_list: [//门票资源类型
                { id: 0,type: "联票"}, 
                { id: 2,type: "单票"},
                { id: 4,type: "套票"}
            ],
            categoryID_list: [//门票资源类型
                { categoryid: 4, title: "景点门票"},
                { categoryid: 40, title: "园内餐饮票"},
                { categoryid: 41, title: "园内交通票"},
                { categoryid: 42, title: "园内演出票"},
                { categoryid: 44, title: "联票"},
                { categoryid: 269, title: "伴手礼（园内）"},
                { categoryid: 270, title: "导览服务"},
                { categoryid: 271, title: "园内服务"},
                { categoryid: 272, title: "游玩项目（园内）"},
                { categoryid: 273, title: "园内套餐"},
                { categoryid: 336, title: "游船票"},
            ],
            peopleGroup_list: [ //适用人群
                { peopleGroup: 1, title: "成人"},
                { peopleGroup: 2, title: "儿童"},
                { peopleGroup: 4, title: "学生"},
                { peopleGroup: 8, title: "老人"},
                { peopleGroup: 16, title: "优待（例如军人、残疾等优待票）"},
                { peopleGroup: 32, title: "亲子家庭"}
            ],
            unitQuantity_list: [ //单位人数
                { unitQuantity: 1, title: "单人票（人/份）"},
                { unitQuantity: 2, title: "双人票"}
            ],
            unitQuantity: 1, //单位人数
            fillInNumberLimit_list: [ //人数限制
                { type: "A", des: "每张一人"}, 
                { type: "O", des: "每单一人"}, 
                { type: "N", des: "无需出行人"}
            ],
            refundNewType_list: [ //退订类型
                { type: 1, des: "随时退"},
                { type: 2, des: "非随时退"},
                { type: 3, des: "不可退"}
            ],
            fillInNumberLimit: "", // 人数限制
            ticket_number: 1, //目前购买数量
            ticket_max_number: 1, //最多购买数量
            ticket_min_number: 1, //最少购买数量
            firstBookingDate: "", //最早可定日期
            checked_date: {}, //选择的日期信息数据 {}
            calendar_checked: {}, // 从日历中选择的日期数据{}
            amount: 0, //总金额
            amount_distribution: 0, //分销总价
            ticket_collector: { //取票人信息
                name: "",
                phone: ""
            },
            ticket_tourist: [ // 游客信息
            ],
            calendarPriceList: [], //价格日历数据
            tipMask: false, //提交订单-提示弹框
            notice: false, //预订须知
            calendarShow: false, //日历展示
            orderInfor: {}, // 订单返回的信息
            resourceOrderExtendInfoList: [], //全部附加信息
        }
    },
    mounted: function() {
        this.getData();
    },
    methods: {
        getValue: function (items) {
            this.resourceOrderExtendInfoList && this.resourceOrderExtendInfoList.forEach((item)=>{
                if (item.ResourceOrderExtendInfoID == items.ResourceOrderExtendInfoID) {
                    item.value = items.value;
                }
            });
        },
        _handle_date: function (val) {
            if(!val) return;
            return val.split('/').map((item)=>{
                return addNumberBeforeZero(item);
            }).join('-');
        },
        handleDate: function (text) {
            if (!text) return;
            let sl = this.trimTime(text);
            let _sl = this.salvation(sl);
            _sl = this._handle_date(_sl);
            return _sl;
        },
        salvation: function (time) {
            if (!time) return;
            let date = new Date(time);
            let _time = date.getFullYear()+'/'+(date.getMonth()+1)+'/'+date.getDate();
            return _time;
        },
        judgeDate: function (time, days=0, clock, isAvailable=false) {
            if (!time || !clock) return;

            const t_time = this.trimTime(time);
            let _time = this.salvation(t_time);
            _time = this._handle_date(_time);

            const currentDate = new Date();//现在
            let deadline_time = clock;

            if (isAvailable) {

                const c_hours = parseInt(addNumberBeforeZero(currentDate.getHours()));
                const c_minutes = parseInt(addNumberBeforeZero(currentDate.getMinutes()));

                let deadline_hours = parseInt(deadline_time.split(":")[0]);
                let deadline_minutes = parseInt(deadline_time.split(":")[1]);

                const _days = 86400000 * days; //提前预定几天的毫秒数
                //今天的时间加上提前预定的天数 后的时间 ==> 相当于目前最早可订时间
                let _next_days = new Date(currentDate.getTime() + _days);
                let next_days = _next_days.getFullYear()+'/'+(_next_days.getMonth()+1)+'/'+_next_days.getDate();
                next_days = this._handle_date(next_days);

                // console.log(next_days > _time, next_days, _time);
            
                if (next_days == _time) {

                    if (deadline_hours > c_hours) {
                        return true;
                    } 
                    else if (deadline_hours = c_hours) {
                        if (deadline_minutes > c_minutes) {
                            return true;
                        } else {
                            return false;
                        }
                    } 
                    else {
                        return false;
                    }
                } else if (next_days < _time) {
                    return true;
                } else {
                    return false;
                }
            }

            let c_currentDate = currentDate.getFullYear()+'/'+(currentDate.getMonth()+1)+'/'+currentDate.getDate();
            c_currentDate = this._handle_date(c_currentDate);//今天

            const tomorrow =  new Date(currentDate.getTime() + 86400000);//明天
            let t_tomorrow = tomorrow.getFullYear()+'/'+(tomorrow.getMonth()+1)+'/'+tomorrow.getDate();
            t_tomorrow = this._handle_date(t_tomorrow);

            const afterTomorrow = new Date(currentDate.getTime() + (86400000*2));//后天
            let a_afterTomorrow = afterTomorrow.getFullYear()+'/'+(afterTomorrow.getMonth()+1)+'/'+afterTomorrow.getDate();
            a_afterTomorrow = this._handle_date(a_afterTomorrow);
            
            if (c_currentDate == _time) {
                return _time + '今天';
            } else if (t_tomorrow == _time) {
                return _time + '明天';
            } else if (a_afterTomorrow == _time) {
                return _time + '后天';
            } else {
                return _time;
            }
        },
        trimTime: function (timer) {
            if (!timer) return;
            const _timer = new Date(parseInt(timer.slice(6, 19)))
            return _timer;
        },
        getCalendarData: function () { //获取价格日历接口
            const id = this.$route.params.id || null;
            this.$dialog.loading.open("正在加载中");
            getCalendarPrice(id).then((res)=>{
                this.$dialog.loading.close();
                // console.log(res,"获取价格日历的接口");
                let data = [];
                res.data && res.data.forEach((item, ind)=>{
                    let date_now = this.trimTime(item.Date);
                    date_now = this.salvation(date_now);
                    data.push({
                        date: date_now.replace(/\//g,'-'),
                        _date: item.Date,
                        price: roundFun(item.CtripPrice,2),
                        _price_self: roundFun(item.Price,2),//分销价
                        _isShow: this.judgeDate(item.Date, this.ticketDate.advanceDays, this.ticketDate.endTime, true)
                    })
                });
                this.calendarPriceList = data;

            }).catch((err)=>{
                console.log(err);
                this.$dialog.loading.close();
            })
        },
        getData: function () { //获取信息
            const id = this.$route.params.id || null;
            this.$dialog.loading.open("正在加载中");
            getTicketForScenicSpotsData(id).then((res)=> {
               this.$dialog.loading.close();
               const data = res.data && res.data.ticketsInfo && res.data.ticketsInfo[0];
            //    console.log(res.data,"数据");

                //附加信息
                let fujiaxinxi = data && data.ResourceOrderExtendInfoList;
                this.resourceOrderExtendInfoList = fujiaxinxi;

                //标题
                this.ticketDate.title = data.Name || "";
                //类型
                this.ticketType_list.forEach((item)=>{
                    if (item.id == data.TicketType) {
                        this.ticketDate.type = item.type;
                    }
                });
                //购票截止时间
                this.ticketDate.endTime = data.AdvanceBookingTime || "";
                //提前预定天数
                this.ticketDate.advanceDays = data.AdvanceBookingDays || 0;
                //最多购买张数
                this.ticket_max_number = data.MaxQuantity || 1;
                //最少购买张数
                this.ticket_min_number = data.MinQuantity || 1;
                //当前购买数量
                this.ticket_number = data.MinQuantity || 1;
                
                //最早可定日期
                this.firstBookingDate = this.handleDate(data.FirstBookingDate) || "";
                
                
        //预定须知 列表
                let _noticeList = [];

                //门票资源类型
                const categoryID = data.CategoryID || "";
                if (categoryID) {
                    this.categoryID_list.forEach((val)=>{
                        if (val.categoryid == categoryID) {
                            _noticeList.push({
                                title: "门票类型",
                                content: [{content: '- '+val.title}]
                            });
                        }
                    });
                }
                //购票截止时间
                 _noticeList.push({
                    title: "购票截止时间",
                    content: [{content: '- '+data.AdvanceBookingTime || ""}]
                });

                //提前预定天数
                _noticeList.push({
                    title: "提前预定天数",
                    content: [{content: data.AdvanceBookingDays == 0 ? "- 当天": '- '+data.AdvanceBookingDays + '天'}]
                });

                // 适用人群
                const _peopleGroup = data.PeopleGroup || "";
                this.peopleGroup_list.forEach((val)=>{
                    if (_peopleGroup == val.peopleGroup) {
                        _noticeList.push({
                            title: "适用人群",
                            content: [{content: '- '+val.title}]
                        });
                    }
                });
                //单位人数
                let _unitQuantity = parseFloat(data.UnitQuantity) || 1;
                this.unitQuantity = _unitQuantity;

                this.unitQuantity_list.forEach((val)=>{
                    if (val.unitQuantity == _unitQuantity) {
                        _noticeList.push({
                            title: "单位人数",
                            content: [{content: '- '+val.title}]
                        });
                    }
                });
                //附加信息
                data.ResourceAddInfoList && data.ResourceAddInfoList.forEach((val)=>{
                    let resource_list_detail = [];
                    val.ResourceAddInfoDetailList && val.ResourceAddInfoDetailList.forEach((item, index)=>{
                        let desc = item.DescDetail || "";
                        resource_list_detail.push({
                            content: `- ${desc}`
                        });
                    })
                    _noticeList.push({
                        title: val.SubTitle,
                        content: resource_list_detail
                    });
                });

                //退订类型
                if (data.RefundNewType) {
                    const _refundNewType = data.RefundNewType;
                    this.refundNewType_list.forEach((val)=>{
                        if (val.type == _refundNewType) {
                                _noticeList.push({
                                title: "退订类型",
                                content: [{content: '- '+val.des}]
                            });
                        }
                    });
                }

                //退订确认时间
                if (data.UnSubscribeTime) {
                    const _unSubscribeTime = data.UnSubscribeTime;
                    _noticeList.push({
                        title: "退订确认时间",
                        content: [{content: '- '+_unSubscribeTime+'小时以内确认'}]
                    });
                };

                //其他信息（文档未描述）
                const _displayTagGroupList = data.DisplayTagGroupList || [];
                _displayTagGroupList && _displayTagGroupList.forEach((value, ind)=>{
                    let value_list = [];
                    value.DisplayTagList && value.DisplayTagList.forEach((valueT)=>{
                        value_list.push({
                            content: '- '+valueT.Value || ""
                        });
                    });
                    _noticeList.push({
                        title: `其他信息${ind+1}`,
                        content: value_list
                    });
                });

        this.noticeList = _noticeList;
                
                let _priceDateObj = res.data && res.data.priceDateList && res.data.priceDateList[0] || {};
                //使用日期
                let _dateList = [];
                let d_abt = data && data.AdvanceBookingTime;
                _priceDateObj && _priceDateObj.DateList && _priceDateObj.DateList.forEach((val, ind)=> {
                    _dateList.push({
                        time: this.judgeDate(val.Date, data.AdvanceBookingDays, d_abt),
                        _time: val.Date, // => /Date(1625155200000+0800)/
                        show: this.judgeDate(val.Date, data.AdvanceBookingDays, d_abt, true), //是否可用
                        price: roundFun(val.CtripPrice,2) || 0, //价格
                        _price_self: roundFun(val.Price,2) || 0, //分销价
                        id: ind, //伪id 下标
                        _id: _priceDateObj.ResourceID || null, //id
                        num: val.InventoryNum || 0//库存
                    });
                });
                
                this.dateList = _dateList;

                //取票人/游客信息
                let _dynamicForm = res.data && res.data.dynamicForm && res.data.dynamicForm.ResourceList && res.data.dynamicForm.ResourceList[0];
                
                // 游客信息
                let _customerInfoItemList= [];
                let _new_tourist = [];
                _dynamicForm.CustomerInfoItemList && _dynamicForm.CustomerInfoItemList.forEach((item)=>{
                   if (item.Model == 2) {
                       _customerInfoItemList.push({
                           text: item.Name,
                           Id: item.ID,
                           value: parseFloat(item.Type)
                       });
                   } else if (item.Model == 1) {
                       _new_tourist.push({...item, value:""});
                   }
                });
                sort( _new_tourist, "ID");
                this.arr = _customerInfoItemList;
                new_tourist = JSON.parse(JSON.stringify(_new_tourist));
                
                
                let _dy_fill = _dynamicForm.FillInNumberLimit;
                this.fillInNumberLimit = _dy_fill;//限制人数
                if (_dy_fill == "A") {//每人一张
                    
                    if (_unitQuantity == 1) { // 单位份数：1
                        for(let tic=0; tic<data.MinQuantity; tic++) {
                            this.ticket_tourist.push({
                              index: tic+1,
                              values: JSON.parse(JSON.stringify(_new_tourist))
                            });
                        }
                            
                        } else if (_unitQuantity == 2) { // 单位份数：2
                            let all_num = (_unitQuantity * data.MinQuantity);//如果张数有问题就循环这个
                            let all_list = [];
                            for(let tict=1; tict<=data.MinQuantity; tict++) {
                                    all_list.push({
                                        index: (tict * 2)-1,
                                        values: JSON.parse(JSON.stringify(_new_tourist))
                                    });
                                    all_list.push({
                                        index: tict * 2,
                                        values: JSON.parse(JSON.stringify(_new_tourist))
                                    });
                            }
                            this.ticket_tourist = all_list;
                        } else if (_unitQuantity == 3) { // 单位份数：3
                            let all_num = (_unitQuantity * data.MinQuantity);//如果张数有问题就循环这个
                            let all_list = [];
                            for(let tict=1; tict<=data.MinQuantity; tict++) {
                                    all_list.push({
                                        index: (tict * 3)-2,
                                        values: JSON.parse(JSON.stringify(_new_tourist))
                                    });
                                    all_list.push({
                                        index: (tict * 3)-1,
                                        values: JSON.parse(JSON.stringify(_new_tourist))
                                    });
                                    all_list.push({
                                        index: tict * 3,
                                        values: JSON.parse(JSON.stringify(_new_tourist))
                                    });
                            }
                            this.ticket_tourist = all_list;
                        } 
                } else if (_dy_fill == "O") {//每单一人
                        this.ticket_tourist.push({
                            index: this.ticket_number,
                            values: [..._new_tourist]
                        });
                } else if (_dy_fill == "N") {//无需出行人
                        this.ticket_tourist = [];
                }

                
    

            }).catch((err)=>{
              console.log(err.msg);
              this.$dialog.error(err.msg);
              this.$dialog.loading.close();
            });
        },
        openCalendarCheck: async function () { //打开日历
            await this.getCalendarData();
            await this.openCalendar(true);
        },
        openCalendar: function (val) { //日历组件
            this.calendarShow = val;
        },
        closeCalendar: function (value) {
            let { close, price, date, show, _date, _price_self } = value;
            if (price && date) {
                let _val = {
                    time: date,
                    _time: _date,
                    show: show,
                    price: price,
                    _price_self: _price_self,
                    id: date
                };
                let isExistenceDate = true;
                let existenceDate = null;
                this.dateList && this.dateList.forEach((item)=>{
                    if (item.time.indexOf(date) !== -1) {
                        isExistenceDate = false;
                        existenceDate = item;
                    }
                });
                if (isExistenceDate) {
                    this.calendar_checked = _val;
                    this.checked_dateFn(_val);
                } else {
                    this.checked_dateFn(existenceDate);
                }
                // console.log(_val,"close");
            }
            this.openCalendar(close); //关闭日历组件
        },
        confirm: function () {//确认 => 跳转到支付界面
            this.tipMask = false;
            this.$router.push('/payForTicket/'+ this.orderInfor.order_id);
        },
        confirmOrder: function () { //确定此订单
            // console.log(this.ticket_collector,"提交订单-获取取票人信息");
            //console.log(this.ticket_tourist,"提交订单-拿到所有游客信息");

            let tourist_information = [];
            this.ticket_tourist && this.ticket_tourist.forEach((val)=>{
                let ChineseName = "";//中文姓名
                let EnglistName = "";//英文姓名
                let Cname = "";//姓名
                let Nationality = "" //国籍
                let ContactInfo = "";//手机号
                let papers_type = "";//证件类型ID
                let papers_name = ""; //证件类型名称
                let papers_number = ""; //证件号码
                let Sex = ""; //性别
                let Birthday = ""; // 出生日期
                let BirthPlace = ""; // 出生地（省份）
                let CardValidUntil = ""; //证件有效期

                //
                let visatype = "";	//港澳签注类型
                let weight = "";	//	体重（kg）
                let height = "";	//	身高（cm）
                let shoesize = "";	//	鞋码（欧码）
                let myopia = "";	//	近视度数（度）
                let issueplace = "";	//	签发地（省份）
                //
                val.values.forEach((item)=>{
                    if (item.ID == 1 && item.Type == "ChineseName") {
                        ChineseName = item.value;
                    }
                    if (item.ID == 2 && item.Type == "EnglishName") {
                        EnglistName = item.value;
                    }
                    if (item.ID == 3 && item.Type == "UserName") {
                        Cname = item.value;
                    }
                    if (item.ID == 4 && item.Type == "Nationality") {
                        Nationality = item.value;
                    }
                    if (item.ID == 5 && item.Type == "IDType") {
                        papers_name = item.value;
                        papers_type = item.idType;
                    }
                    if (item.ID == 6 && item.Type == "Sex") {
                        Sex = parseInt(item.value);
                    }
                    if (item.ID == 7 && item.Type == "IDNumber") {
                        papers_number = item.value;
                    }
                    if (item.ID == 8 && item.Type == "Birthday") {
                        Birthday = item.value;
                    }
                    if (item.ID == 9 && item.Type == "BirthPlace") {
                        BirthPlace = item.value;
                    }
                    if (item.ID == 10 && item.Type == "CardValidUntil") {
                        CardValidUntil = item.value;
                    }
                    if (item.ID == 11 && item.Type == "ContactPhone") {
                        ContactInfo = item.value;
                    }
                    //
                    if (item.ID == 31 && item.Type == "131") {
                        visatype = item.value;
                    }
                    if (item.ID == 32 && item.Type == "132") {
                        weight = item.value;
                    }
                    if (item.ID == 33 && item.Type == "133") {
                        height = item.value;
                    }
                    if (item.ID == 34 && item.Type == "134") {
                        shoesize = item.value;
                    }
                    if (item.ID == 35 && item.Type == "135") {
                        myopia = item.value;
                    }
                    if (item.ID == 36 && item.Type == "136") {
                        issueplace = item.value;
                    }
                });

                let c_cn = Cname && judgeChinese(Cname) ? Cname : "";
                let e_en = Cname && judgeChinese(Cname) ? "" : Cname;
                //console.log(c_cn,"<=", e_en, "<=","判断(*^▽^*)",ChineseName, "<=",EnglistName, "<=");

                tourist_information.push({
                    Cname: ChineseName || c_cn,
                    Ename: EnglistName || e_en,
                    ContactInfo: ContactInfo,
                    idcardtype: papers_type,
                    idcardname: papers_name,
                    idcardno: papers_number,
                    nationality: Nationality,
                    sex: Sex,
                    birthday: Birthday,
                    birth_place: BirthPlace,
                    cardvaliduntil: CardValidUntil,
                    visatype: visatype,
                    weight:	weight,
                    height: height,
                    shoesize: shoesize,
                    myopia: myopia,
                    issueplace: issueplace
                });
            })

            let getExtendInfo = []; // 附加信息
            this.resourceOrderExtendInfoList && this.resourceOrderExtendInfoList.forEach((lis)=>{
                let getInfo = [];
                lis.value && lis.value.forEach((tem)=>{
                    getInfo.push({
                        ID: tem.id || (lis.ResourceOrderExtendInfoItemList && lis.ResourceOrderExtendInfoItemList[0] && lis.ResourceOrderExtendInfoItemList[0].ResourceOrderExtendInfoItemID) || 1,
                        Content: tem.value
                    });
                });
                getExtendInfo.push({
                    ResourceOrderExtendInfoID: lis.ResourceOrderExtendInfoID,
                    AddInfoDetails: getInfo
                });
            });

            let data = {
                "crtip_id": this.$route.params.crtip_id, //景点id
                "resourceInfoList": [{ //下单门票信息
                    "ResourceID": this.$route.params.id, //门票资源id
                    "Quantity": this.ticket_number || 1, //预定数量
                    "UseDate": this.checked_date._time,//使用日期（客人入园日期）
                    "Price": this.checked_date._price_self,//分销价（单价）
                }],
                "contactInfo": { //联系人信息
                    "Name": this.ticket_collector.name || "",//联系人姓名
                    "Mobile": this.ticket_collector.phone || "",//联系人手机（短信接收）
                },
                "passenerInfoList": tourist_information, //出行人信息
                "amount": this.amount_distribution,//订单支付金额—-Sum(资源单价*资源数量)this.amount 
                "ItemAddInfos": getExtendInfo //附加信息
            };
            // console.log(this.checked_date._price_self,"this.checked_date._price_self");
            data.resourceInfoList = JSON.stringify(data.resourceInfoList);
            data.contactInfo = JSON.stringify(data.contactInfo);
            data.passenerInfoList = JSON.stringify(data.passenerInfoList);
            //调接口
            this.$dialog.loading.open("正在提交...");
            preservationData(data).then((res)=>{
                this.$dialog.loading.close();
                // console.log(res,"res");
                let data = res && res.data && res.data.orderInfo;
                this.orderInfor = {
                    title: data.tickets_name || "",
                    time: this.handleDate(data.use_time) || "",
                    number: parseInt(data.total_num) || "",
                    amount: (parseInt(data.total_num)*roundFun(data.ctripprice, 2)) || "",
                    order_id: data.id || ""
                };

                this.tipMask = true;


            }).catch(err=>{
                console.log(err);
                this.$dialog.loading.close();
                this.$dialog.toast({ mes: err.msg });
            });


            // 跳转到门票支付页面
        },
        closeNotice: function (val) { //预订须知
            this.notice = val;
        },
        closeMask: function (val) { //提交订单提示弹窗开关
            this.tipMask = val;
            this.$dialog.toast({ mes: "订单已提交！待支付" });
            this.$router.push("/user");
        },
        completeInfo: async function (item, val, isReturn) {//验证
            // console.log(item, val,"验证")
            let isr = isReturn || false;
            if (item == 'UserName') {
                let name = val;
                try {
                    await this.$validator({
                        name: [
                            required(required.message("姓名")),
                            attrs.range([2, 16], attrs.range.message("姓名"))
                        ]
                    }).validate({ name });
                } catch (e) {
                    if (isr) {
                        console.log("true1");
                        validatorDefaultCatch(e);
                        return false;
                    } else {
                        return validatorDefaultCatch(e);
                    }
                }
            } else if (item == 'EnglishName') {
                let Ename = val;
                try {
                    await this.$validator({
                        Ename: [
                            required(required.message("英文姓名")),
                            alpha_letter(alpha_letter.message("英文姓名"))
                        ]
                    }).validate({ Ename });
                } catch (e) {
                    if (isr) {
                        console.log(e, "true1.25");
                        validatorDefaultCatch(e);
                        return false;
                    } else {
                        return validatorDefaultCatch(e);
                    }
                }
            } else if (item == 'ChineseName') {
                let Cname = val;
                try {
                    await this.$validator({
                        Cname: [
                            required(required.message("中文姓名")),
                            chs(chs.message("中文姓名"))
                        ]
                    }).validate({ Cname });
                } catch (e) {
                    if (isr) {
                        console.log(e, "true1.5");
                        validatorDefaultCatch(e);
                        return false;
                    } else {
                        return validatorDefaultCatch(e);
                    }
                }
            } else if (item == 'ContactPhone') {
                let phone = val;
                try {
                    await this.$validator({
                        phone: [
                            required(required.message("手机号")),
                            chs_phone(chs_phone.message())
                        ]
                    }).validate({ phone });
                } catch (e) {
                    if (isr) {
                         console.log("true2");
                        validatorDefaultCatch(e);
                        return false;
                    } else {
                        return validatorDefaultCatch(e);
                    }
                }
            } else if (item == 'IDNumber') {
                let id = val;
                try {
                    await this.$validator({
                        id: [
                            required(required.message("证件号")),
                            chs_id(chs_id.message())
                        ]
                    }).validate({ id });
                } catch (e) {
                    if (isr) {
                         console.log("true3");
                        validatorDefaultCatch(e);
                        return false;
                    } else {
                        return validatorDefaultCatch(e);
                    }
                }
            }

        },
        touristInfo: function (vals) {
            this.ticket_tourist.forEach((val, ind)=> {
                if (val.index === vals.index) {
                    this.ticket_tourist.splice(ind, 1, vals);
                }
            })
            // console.log(this.ticket_tourist,"this.ticket_tourist----获取到新的啦");
        },
        changeTicketNumber: function(id) {
            if (id === 0) { // 减
                if (this.ticket_number <= this.ticket_min_number) {
                    this.ticket_number = this.ticket_min_number;
                    this.$dialog.toast({ mes: "最少购买"+ this.ticket_min_number + "张"});
                } else {
                    this.ticket_number-=1;
                    this.amount = parseFloat(this.checked_date.price || 0)*this.ticket_number;
                    this.amount_distribution = roundFun(parseFloat(this.checked_date._price_self || 0)*this.ticket_number, 2);

                    if ( this.fillInNumberLimit == "A" ) { // 每人一张
                        if (this.unitQuantity == 1) { // 单位份数：1
                            this.ticket_tourist.splice(this.ticket_tourist.length-1, 1);
                        } else if (this.unitQuantity == 2) { // 单位份数：2
                            this.ticket_tourist.splice(this.ticket_tourist.length-2, 2);
                        } else if (this.unitQuantity == 3) { // 单位份数：3
                            this.ticket_tourist.splice(this.ticket_tourist.length-3, 3);
                        }
                    } else if ( this.fillInNumberLimit == "O" ) { // 每单一人
                        return;
                    } else if ( this.fillInNumberLimit == "N" ) { // 无需出行人信息
                        return;
                    }
                }
            }
            if (id === 1) {// 加
                if (this.ticket_number >= this.ticket_max_number) {
                    this.ticket_number = this.ticket_max_number;
                    this.$dialog.toast({ mes: "最多购买"+ this.ticket_max_number + "张"});
                } else {
                    this.ticket_number+=1;
                    this.amount = parseFloat(this.checked_date.price || 0)*this.ticket_number;
                    this.amount_distribution = roundFun(parseFloat(this.checked_date._price_self || 0)*this.ticket_number, 2);
                    this.$nextTick(()=>{
                        //计算：人数限制 * 单位份数 * 数量
                        // this.fillInNumberLimit * this.unitQuantity * this.ticket_number
                    if ( this.fillInNumberLimit == "A" ) { // 每人一张
                        if (this.unitQuantity == 1) { // 单位份数：1
                            this.ticket_tourist.push({
                                index: this.ticket_number,
                                values: JSON.parse(JSON.stringify(new_tourist))
                            });
                        } else if (this.unitQuantity == 2) { // 单位份数：2
                            let all_num = (this.unitQuantity * this.ticket_number) - 1;
                            for (let n = 0; n < 2; n++) {
                                // console.log(all_num, all_num + n);
                                this.ticket_tourist.push({
                                    index: all_num + n,
                                    values: JSON.parse(JSON.stringify(new_tourist))
                                });
                            }
                        } else if (this.unitQuantity == 3) { // 单位份数：3
                            let all_num = (this.unitQuantity * this.ticket_number) - 2;
                            for (let n = 0; n < 3; n++) {
                                // console.log(all_num, all_num + n);
                                this.ticket_tourist.push({
                                    index: all_num + n,
                                    values: JSON.parse(JSON.stringify(new_tourist))
                                });
                            }
                        } 
                    } else if ( this.fillInNumberLimit == "O" ) { // 每单一人
                        // 只留一个
                        return;
                    } else if ( this.fillInNumberLimit == "N" ) { // 无需出行人信息
                        return;
                    }

                    })
                }
            }
        },
        checked_dateFn: function(val) {
            if (val.show) {
                if (val.id === this.checked_date.id) return;
                this.checked_date = {...val};
                this.amount = parseFloat(val.price)*this.ticket_number;
                this.amount_distribution = roundFun(parseFloat(val._price_self)*this.ticket_number, 2)
            }
        },

        submit_order: async function () {

            if (isEmpty(this.checked_date)) {
                this.$dialog.error("请选择日期");
                return;
            }
            //检查订单信息是否完善
            for (let item of Object.values(this.ticket_collector)) {
                if (!item) {
                    this.$dialog.error("请将取票人信息填写完整");
                    return;
                }
            }
            //console.log(this.ticket_collector,"提交订单-拿到取票人信息",this.ticket_tourist);

            //检查游客信息是否完善
            if (this.ticket_tourist.length != 0) {
                let isTrue = true;
                for(let i = 0; i < this.ticket_tourist.length; i++) {
                    let isId = false;
                    for (let u = 0; u < this.ticket_tourist[i].values.length; u++) {
                        for (let [item,val] of Object.entries(this.ticket_tourist[i].values[u])) {
                                if (!val && item == 'value') {
                                    console.log(item,val,"那个没写我看看")
                                    this.$dialog.error("请将游客信息填写完整");
                                    return;
                                }
                        }
                        let _userInfo = this.ticket_tourist[i].values[u];
                        if (_userInfo.Type == 'IDType' && _userInfo.value == '身份证' && _userInfo.idType == 13) {
                            isId = true;//判断 证件类型 是否是 身份证
                        }
                        if (_userInfo.Type == "Sex") {
                            let _sex = parseInt(_userInfo.value.trim());
                            if (_sex != 1 || _sex != 2) {
                                this.$dialog.error("性别1:男 2:女，请输入1或2");
                                return;
                            }
                        }
                        //_userInfo.Type == "EnglishName" || 
                        if (_userInfo.Type == "UserName"  || (_userInfo.Type == "IDNumber" && isId) || _userInfo.Type == "ContactPhone" || _userInfo.Type == "ChineseName") {
                            await this.completeInfo(_userInfo.Type, _userInfo.value, true).then((item)=>{
                                if (item === false) {
                                    isTrue = item;
                                    return;
                                }
                            });
                            if (!isTrue) return;
                        }
                    }
                }
            }

            if (this.resourceOrderExtendInfoList.length !== 0 ) {
                for (let i = 0; i < this.resourceOrderExtendInfoList.length; i++) {
                    if (!this.resourceOrderExtendInfoList[i].value || this.resourceOrderExtendInfoList[i].value.length == 0 ) {
                        // console.log(this.resourceOrderExtendInfoList[i]);
                        this.$dialog.error("请将附加信息填写完整");
                        return;
                    }
                }
            }
            


            //提交订单
            this.confirmOrder();
        }
    }
}
</script>

<style scoped>
.wrapper-content {
    padding-bottom: 1rem;
}
.cancel-tab {
    border-right: .02rem solid #eee;
}
.mask-top-wrapper {
    border-bottom: .02rem solid #eee;
}
.ticket-Order {
    padding-bottom: 1.2rem;
}
.ticket-order-info-wrapper {
    width: 92%;
    margin: .2rem auto 0;
    border-radius: .1rem;
}
.ticket-order-info-top {
    border-bottom: .02rem solid #eee;
    font-size: .34rem;
}
.padding-top-bottom {
    padding: .3rem 0 .2rem;
}
.ticket-type {
    width: 70%;
}
.order-info-tip-wrapper {
    font-size: .28rem;
    margin-top: .2rem;
}
.ticket-text-color {
    color: #666;
}
.ticket-margin-bottom {
    margin-bottom: .3rem;
}
.ticket-line {
    display: inline-block;
    padding-right: .17rem;
    margin-right: .1rem;
    border-right: .02rem solid #666;
}
.choose-date-wrapper {
    padding-right: .8rem;
}
.more {
    top: 50%;
    right: 0;
    transform: translate(0,-50%);
}
.ticket-font-size {
    font-size: .38rem;
    line-height: .7rem;
}
.date-modul {
    flex: 1;
    border-radius: .1rem;
    border: .02rem solid #fc4141;
    font-size: .26rem;
    padding: .1rem;
}
.ticket-margin-right {
    margin-right: .1rem;
}
.no-ticket {
    background: #eee;
    border: .02rem solid #ccc;
    color: #666;
}
.ticket-number {
    display: inline-block;
    width: .4rem;
    height: .4rem;
    border-radius: 50%;
    border: .02rem solid #fc4141;
    text-align: center;
    line-height: .35rem;
    font-size: .4rem;
}
.ticket-reduce {
    background: #fff;
    color: #fc4141;
}
.ticket-add {
    background: #fc4141;
    color: #fff;
}
.ticket-number-wrapper {
   width: 1.8rem;
}
.checked-date {
    background: #FF5A5F;
    color: #fff;
}
.label-wrapper {
    height: .8rem;
    font-size: .32rem;
}
.input-text {
    height: 100%;
    width: 75%;
}

</style>